<template>
  <section class="l-content-area">
    <div class="l-content l-content--reservation">
      <div class="l-wrap__outer">
        <div class="l-wrap__inner">
          <section class="c-title__bloc c-title__bloc--reservation">
            <h1>新規来店予約申し込み登録</h1>
            <div class="c-btn c-btn--title-back"><a href="#">戻る</a></div>
          </section>
          <section class="p-bloc p-bloc__reservation">
            <h2 class="p-reservation__step">STEP 5</h2>
            <div class="p-reservation__bloc">
              <p>日程調整に関して下記内容のご回答をお願いいたします。</p>
              <div class="p-reservation__contact">
                <dl class="c-contact-parts">
                  <dt>ご連絡手段</dt>
                  <dd>
                    <input-radio
                      :value="values.contact"
                      :error="errors.contact"
                      :text-error="textErrors.contact"
                      :name="'contact'"
                      :list-data="listContactMethod"
                      @onHandleChange="onHandleChange"
                      @onValidate="onValidate"
                    >
                    </input-radio>
                  </dd>
                  <dt>ご連絡タイミング <span>※入力は100文字まで</span></dt>
                  <dd>
                    <text-area
                      :name="'other'"
                      :value="values.other"
                      :max-length="100"
                      :placeholder="'ご希望される時間帯などあればご入力をお願い致します。'"
                      :error="errors.other"
                      :is-show-error="false"
                      :text-error="textErrors.other"
                      :pattern="regex"
                      @onValidate="onValidate"
                      @onHandleChange="onHandleChange"
                    ></text-area>
                    <error-message v-if="errors.other" :error="errors.other"></error-message>
                  </dd>
                </dl>
              </div>
            </div>
            <button-registration
              :next-text="'次へ'"
              :prev-text="'戻る'"
              :handle-next-button="nextToStep"
              :handle-prev-button="prevToStep"
              :prev-text-color="'#787878'"
            ></button-registration>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import ButtonRegistration from '../common/ButtonRegistration'
import TextArea from '../common/TextArea'
import { listQuestions, listContactMethod } from '../../constant/listQuestions'
import { COMMENT_INVALID, QUESTION_INVALID, CONTACT_INVALID } from '../../constant/text'
import { rulesValidateReservationQuestion } from '../../helpers/schemaValidate'
import InputSelectValueIndex from '../common/InputSelectValueIndex'
import InputRadio from '../common/InputRadio'
import { requestReminders } from '../../actions/requestReservation'
import { scrollToTop } from '../../helpers'
import * as regex from '../../helpers/regex'
import ErrorMessage from '../common/ErrorMessage'

export default {
  name: 'ReservationQuestion',
  components: {
    InputRadio,
    ButtonRegistration,
    TextArea,
    InputSelectValueIndex,
    ErrorMessage,
  },
  props: {
    currentStep: {
      type: String,
      default: '5',
    },
    isForceValidate: {
      type: Boolean,
      default: false,
    },
    isConclusion: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: String,
      default: '',
    },
    reminderId: {
      type: String,
      default: '',
    },
    values: {
      type: Object,
      default: () => {
        return {
          other: '',
          question: '',
          contact: '',
        }
      },
    },
  },
  data() {
    return {
      listQuestions,
      listContactMethod,
      errors: {
        other: '',
        question: '',
        contact: '',
      },
      textErrors: {
        question: QUESTION_INVALID,
        other: COMMENT_INVALID,
        contact: CONTACT_INVALID,
      },
      regex: regex.patternEmoji,
    }
  },
  watch: {
    isForceValidate(newVal) {
      if (
        newVal &&
        ((this.currentStep === '5' && !this.isConclusion) ||
          (this.isConclusion && this.currentStep === '6'))
      ) {
        this.nextToStep()
      }
    },
  },
  methods: {
    onValidate(field, value) {
      this.errors[field] = value
      this.textErrors[field] = value
      this.$emit('onValidateSwipe', false)
    },
    nextToStep() {
      rulesValidateReservationQuestion
        .validate(this.values, { abortEarly: false })
        .then(() => {
          this.$emit('startLoading')
          this.values.other = this.values.other.replaceAll(regex.patternEmojiRestrict, '')
          requestReminders(this.userId, this.values, this.reminderId)
            .then(response => {
              const {
                data: { success },
              } = response
              if (success && success === 1) {
                const {
                  data: { data },
                } = response
                this.$emit('setReminderId', data.id.toString())
                this.$emit('nextToStep', 3)
                this.$emit('endLoading')
              }
            })
            .catch(error => {
              this.$emit('endLoading')
              return error
            })
        })
        .catch(err => {
          scrollToTop(0, 0)
          err.inner.forEach(error => {
            this.errors[error.path] = error.message
            this.$emit('endLoading')
          })
        })
    },
    prevToStep() {
      this.$emit('prevToStep', 1)
    },
    onHandleChange(field, value) {
      this.$emit('onHandleChange', field, value)
    },
    onValidateContact() {
      this.errors.contact = ''
    },
  },
}
</script>
<style scoped>
.v-application ul,
.v-application ol {
  padding-left: 0 !important;
}

.v-application a {
  color: #0a005a;
}
</style>
